import { Button, Grid, GridItem } from "@chakra-ui/react";
import { t } from "i18next";
import "./index.css";
import { HintButton } from "./HintButton";
import { useState } from "react";

interface GameActionCenterProps {
  airline: string;
  altitude: string;
  duration: string;
  originTimezone: string;
  destinationTimezone: string;
  onRevealHint: (hintId: string) => void;
  onGiveUp: () => void;
}

export const GameActionCenter = ({
  airline,
  altitude,
  duration,
  originTimezone,
  destinationTimezone,
  onRevealHint,
  onGiveUp,
}: GameActionCenterProps) => {
  const [confirmingGiveUp, setConfirmingGiveUp] = useState(false);

  return (
    <>
      <Grid
        templateColumns="repeat(2, 1fr)"
        gap={2}
        pointerEvents="auto"
        paddingRight={{ base: 0, md: 5 }}
        paddingBottom={{ base: 5, md: 0 }}
      >
        <GridItem colSpan={2}>
          <HintButton
            hintId="airline"
            value={airline}
            onReveal={() => onRevealHint("airline")}
          />
        </GridItem>
        <GridItem>
          <HintButton
            hintId="altitude"
            value={altitude}
            onReveal={() => onRevealHint("altitude")}
          />
        </GridItem>
        <GridItem>
          <HintButton
            hintId="duration"
            value={duration}
            onReveal={() => onRevealHint("duration")}
          />
        </GridItem>
        <GridItem>
          <HintButton
            hintId="originTimezone"
            value={originTimezone}
            onReveal={() => onRevealHint("originTimezone")}
          />
        </GridItem>
        <GridItem>
          <HintButton
            hintId="destinationTimezone"
            value={destinationTimezone}
            onReveal={() => onRevealHint("destinationTimezone")}
          />
        </GridItem>
        <GridItem colSpan={2} marginTop={2}>
          <Button
            width="100%"
            backgroundColor={confirmingGiveUp ? "red" : "blackAlpha.700"}
            paddingLeft={{
              base: "100px",
              md: confirmingGiveUp ? "220px" : "230px",
              lg: confirmingGiveUp ? "220px" : "270px",
            }}
            paddingRight={{
              base: "100px",
              md: confirmingGiveUp ? "220px" : "230px",
              lg: confirmingGiveUp ? "220px" : "270px",
            }}
            maxW={"100%"}
            colorScheme="red"
            onClick={() => {
              if (confirmingGiveUp) {
                onGiveUp();
              } else {
                setConfirmingGiveUp(true);

                setTimeout(() => {
                  setConfirmingGiveUp(false);
                }, 3000);
              }
            }}
          >
            {confirmingGiveUp
              ? t("game.controls.giveUp.confirm")
              : t("game.controls.giveUp.initial")}
          </Button>
        </GridItem>
      </Grid>
    </>
  );
};
